// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { AlertIcon, Flex, Typography } from '@iheartjane/reefer';

const TitleText = styled(Typography)({
  fontSize: '32px',
});

export const NotFoundPage = () => {
  return (
    <Flex width="432px" mx="auto" justifyContent="center">
      <Flex
        my={128}
        mx={40}
        justifyContent="flex-start"
        alignItems="center"
        flexDirection="column"
        width="432px"
      >
        <AlertIcon size="xxl" mb={24} />
        <Flex flexDirection="column" width="432px">
          <TitleText mb={8} variant="h1-semibold" textAlign="center">
            Oops. Didn&rsquo;t find what you were looking for.
          </TitleText>
        </Flex>
      </Flex>
    </Flex>
  );
};
